import LearnSuggestionService from '@/services/LearnSuggestionService'

const createLearnSuggestionsModule = () => ({
  namespaced: true,
  state: {
    page: 1,
    pages: 1,
    pageSize: 15,
    total: 0,
    learnSuggestions: []
  },
  actions: {
    getLearnSuggestions: ({ commit, state }) => {
      LearnSuggestionService.getLearnSuggestions(state.pageSize, state.page)
        .then((data) => {
          commit('SET_LEARN_SUGGESTIONS', {
            learnSuggestions: data.learnSuggestions
          })
          commit('SET_PAGES', { pages: data.pages })
          commit('SET_TOTAL', { total: data.total })
        })
        .catch((err) => {
          console.info(err)
        })
    },
    setPage: ({ dispatch, commit, state }, page) => {
      commit('SET_PAGE', { page })
      dispatch('getLearnSuggestions')
    }
  },
  getters: {
    prevDisabled: (state) => state.page === 1,
    nextDisabled(state) {
      return state.pageSize * state.page >= state.total
    }
  },
  mutations: {
    SET_LEARN_SUGGESTIONS: (state, { learnSuggestions }) => {
      state.learnSuggestions = learnSuggestions
    },
    SET_PAGES: (state, { pages }) => {
      state.pages = pages
    },
    SET_PAGE: (state, { page }) => {
      state.page = page
    },
    SET_TOTAL: (state, { total }) => {
      state.total = total
    }
  }
})

export default createLearnSuggestionsModule
